import type { SVGProps } from 'react'

export const IconPlus = (props: SVGProps<SVGSVGElement>) => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M11.999 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 11.999 22C6.485 22 2 17.514 2 12C2 6.486 6.485 2 11.999 2ZM11.999 24C18.627 24 24 18.628 24 12C24 5.372 18.627 -3.25685e-06 11.999 -2.09797e-06C5.372 -9.3927e-07 9.3927e-07 5.372 2.09815e-06 12C3.25702e-06 18.628 5.372 24 11.999 24ZM16.5 13C17.053 13 17.5 12.553 17.5 12C17.5 11.447 17.053 11 16.5 11L13 11L13 7.5C13 6.947 12.553 6.5 12 6.5C11.447 6.5 11 6.947 11 7.5L11 11L7.5 11C6.947 11 6.5 11.447 6.5 12C6.5 12.553 6.947 13 7.5 13L11 13L11 16.5C11 17.053 11.447 17.5 12 17.5C12.553 17.5 13 17.053 13 16.5L13 13L16.5 13Z'
			fill='currentColor'
		/>
	</svg>
)
